import { atom } from 'jotai'

import { claimSpiritMachineAtom } from '@/features/spirit/atoms/claimSpiritMachineAtom'
import { originalVariants, injectedVariants, claimedVariants } from '../animationVariants'

export enum ClaimSpiritStageEnum {
  waiting = 'waiting',
  defaults = 'defaults',
  original = 'original',
  injected = 'injected',
  claimed = 'claimed',
  closed = 'closed',
}

export const claimSpiritStageAtom = atom(get => {
  const machine = get(claimSpiritMachineAtom)
  const isClaimed = !!machine.context.spirit && machine.context.spiritCollection?.length > 0
  const isOriginal = !isClaimed && !machine.context.linked?.substrate
  // const isInjected = (machine.matches('signedIn.linked') || machine.matches('signedIn.created') || machine.matches('signedIn.ready'))
  const isInjected = !isOriginal
  if (machine.matches('signedIn.waiting')) {
    return ClaimSpiritStageEnum.waiting
  }
  if (machine.matches('signedIn.closed')) {
    return ClaimSpiritStageEnum.closed
  }
  if (isClaimed) {
    return ClaimSpiritStageEnum.claimed
  }
  if (isInjected) {
    return ClaimSpiritStageEnum.injected
  }
  if (isOriginal) {
    return ClaimSpiritStageEnum.original
  }
  return ClaimSpiritStageEnum.defaults
})

export const claimSpiritStageAnimateAtom = atom(get => {
  const stage = get(claimSpiritStageAtom)
  if (stage === ClaimSpiritStageEnum.claimed) {
    return claimedVariants
  }
  if (stage === ClaimSpiritStageEnum.injected) {
    return injectedVariants
  }
  return originalVariants
})
